import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as AP from "fp-ts/Apply"
import { AirParamsFlight } from '@ssc-booking/api-contracts';
import * as AirClass from '@ssc-booking/api-contracts/src/air-class';
import { FareCardKey } from "../features/_common/read-models/fare-card"

const separator = "--"
const sequenceO = AP.sequenceS(O.Applicative)

type FareKeyAndAir = { key: FareCardKey; air: AirParamsFlight }
export const encodeAirFare = (maybeFlight: O.Option<FareKeyAndAir>) =>
    F.pipe(
        maybeFlight,
        O.map((x) => `${x.key}${separator}${airClass.get(x.air)}`),
    )

type DecodedAirFare = { key: FareCardKey; airClass: AirClass.AirClass }
export const decodeAirFare = (encodedAirFare: string): O.Option<DecodedAirFare> =>
    F.pipe(
        encodedAirFare.split(separator),
        O.fromPredicate((x) => x.length === 2),
        O.chain((x) =>
            F.pipe(
                {
                    key: F.pipe(FareCardKey.decode(x[0]), O.fromEither),
                    airClass: F.pipe(AirClass.strictType.decode(x[1]), O.fromEither),
                },
                sequenceO,
                O.map((x): DecodedAirFare => ({ key: x.key, airClass: x.airClass })),
            ),
        ),
    )

const airClass = AirParamsFlight.lensFromProp("airClass")
